<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="selectedRowApplicant"
            :value.sync="currentValue"
            display-expr="성명"
            value-expr="성명"
            content-template="contentTemplate"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refCompanyGrid'
              :remote-operations="true"
              :data-source='applicantInfoList'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="false"
                placeholder="검색..."
              />
              <DxFilterRow
                :visible="true"
                apply-filter="auto"
              />
              <DxColumn
                :fixed="true"
                caption="성명"
                data-field="성명"
                width = '70'>
              </DxColumn>
              <DxColumn
                :allowEditing="true"
                :visible="true"
                caption="성별"
                data-field="성별"
                alignment="center"
                :min-width="60"
              >
                <DxLookup
                  :data-source="manWoomanLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
              </DxColumn>
              <DxColumn
                :allowEditing="true"
                :visible="true"
                caption="생년월일"
                data-field="생년월일"
                alignment="center"
                format="yyyy-MM-dd"
                dataType="date"
                :min-width="100"
              >
              </DxColumn>

              <DxColumn
                caption="컨설턴트"
                data-field="컨설턴트"
                width = '100'>
              </DxColumn>
              <dx-paging :enabled="true" :page-size="pageSize"/>
              <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="single"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxFilterRow, DxLookup } from 'devextreme-vue/data-grid'
import CustomStore from 'devextreme/data/custom_store'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
import ConstDef from '../../ConstDef'

export default {
  name: 'companyGrid',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 400 },
      gridHeight: 500,
      applicantInfoList: null,
      dataSource: null,
      manWoomanLookup: ConstDef.남녀,
      pageSize: 100,
      selectedRowApplicant: []
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // // console.log(data)
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox,
    DxFilterRow,
    DxLookup
  },
  computed: {
  },
  created () {
    // console.log('Employee Component**********')
    const vue = this
    this.applicantInfoList = new CustomStore({
      key: 'seqId',
      load (loadOptions) {
        const postParam = {}
        const temp =
          [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary'
          ]
        temp.forEach((key) => {
          if (key in loadOptions && vue.$_appLib.isNotEmpty(loadOptions[key])) {
            if (key === 'filter') {
              console.log(loadOptions[key])
              const filterArray = []
              if (loadOptions[key][1] !== 'and') {
                if (loadOptions[key][0] === 'createdTime' || loadOptions[key][0] === 'updatedTime') {
                  loadOptions[key][2] = vue.$_appLib.formatDate(loadOptions[key][2])
                }
                filterArray.push(loadOptions[key])
              } else {
                loadOptions[key].forEach(item => {
                  if (Array.isArray(item) && Array.isArray(item[0])) {
                    item.forEach(row => {
                      // console.log(row)
                      if (Array.isArray(row) && (row[0] === 'createdTime' || row[0] === 'updatedTime')) {
                        row[2] = vue.$_appLib.formatDate(row[2])
                      }
                      if (Array.isArray(row)) filterArray.push(row)
                    })
                  } else {
                    if (item[0] === 'createdTime' || item[0] === 'updatedTime') {
                      item[2] = vue.$_appLib.formatDate(item[2])
                    }
                    if (Array.isArray(item)) filterArray.push(item)
                  }
                })
              }
              postParam[key] = filterArray
            } else {
              postParam[key] = loadOptions[key]
            }
            // console.log(key, JSON.stringify(loadOptions[key]))
          }
        })
        console.log(postParam)
        return vue.$_sp.runFindSqlDevCustomeProc('지원대상자', postParam)
          .then(rseponse => (
            // console.log(JSON.parse(rseponse.data))
            {
              data: JSON.parse(rseponse.data),
              totalCount: rseponse.totalCount,
              summary: [rseponse.totalCount]
            }
          ))
          .catch(() => { throw new Error('Data Loading Error') })
      }
    })
  },
  mounted () {
    console.log(this.currentValue)
  },
  updated () {
    // console.log(this.value)
  },
  beforeDestroy: function () {

  },
  methods: {
    onValueChangedDropBox (e) {

    },
    onSelectionChanged (e) {
      console.log(e.selectedRowsData[0])
      this.selectedRowApplicant = e.selectedRowsData
      this.currentValue = this.selectedRowApplicant[0].성명
      // this.onValueChangedDropBox(this.selectedRowApplicant)
      this.$emit('change-selected', this.selectedRowApplicant[0])
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
